<template>
  <Modal :show="show" size="sm" @close="$emit('close')">
    <template #header>
      <div class="header">
        <div class="icon-wrapper warning">
          <Icon icon="mdi:alert" class="icon warning-icon" />
        </div>
        <h2 class="title">Large Contact List Detected</h2>
      </div>
    </template>

    <div class="body">
      <p class="text">
        You are about to search for <strong>{{ estimatedContacts }} contacts</strong> from your
        LinkedIn Sales Navigator search. This may take a while to process.
      </p>
      <p class="text" style="margin-top: 12px">Are you sure you want to continue?</p>
    </div>

    <template #footer>
      <div class="footer">
        <Button variant="secondary" size="md" @click="$emit('close')"> Cancel </Button>
        <Button
          variant="primary"
          size="md"
          :loading="loading"
          :disabled="loading"
          @click="$emit('confirm')"
        >
          Continue
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, Icon } from "@/components/ui";

defineProps<{
  show: boolean;
  estimatedContacts: number;
  loading?: boolean;
}>();

defineEmits<{
  close: [];
  confirm: [];
}>();
</script>

<style scoped>
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background-color: #eff6ff;
  border-radius: 50%;
}

.icon-wrapper.warning {
  background-color: #fef3c7;
}

.icon {
  font-size: 32px;
  color: #3e3efe;
}

.warning-icon {
  color: #f59e0b;
}

.title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  line-height: 1.4;
}

.body {
  padding: 24px;
}

.text {
  margin: 0;
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.6;
  text-align: center;
}

.text strong {
  color: #111827;
  font-weight: 600;
}

.footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  width: 100%;
}
</style>
